import type { SVGProps } from "react";

export const DotsGridIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M5.33268 4.00002C5.70087 4.00002 5.99935 3.70154 5.99935 3.33335C5.99935 2.96516 5.70087 2.66669 5.33268 2.66669C4.96449 2.66669 4.66602 2.96516 4.66602 3.33335C4.66602 3.70154 4.96449 4.00002 5.33268 4.00002Z"
      stroke="#D4D4D4"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33268 8.66669C5.70087 8.66669 5.99935 8.36821 5.99935 8.00002C5.99935 7.63183 5.70087 7.33335 5.33268 7.33335C4.96449 7.33335 4.66602 7.63183 4.66602 8.00002C4.66602 8.36821 4.96449 8.66669 5.33268 8.66669Z"
      stroke="#D4D4D4"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33268 13.3334C5.70087 13.3334 5.99935 13.0349 5.99935 12.6667C5.99935 12.2985 5.70087 12 5.33268 12C4.96449 12 4.66602 12.2985 4.66602 12.6667C4.66602 13.0349 4.96449 13.3334 5.33268 13.3334Z"
      stroke="#D4D4D4"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99935 4.00002C10.3675 4.00002 10.666 3.70154 10.666 3.33335C10.666 2.96516 10.3675 2.66669 9.99935 2.66669C9.63116 2.66669 9.33268 2.96516 9.33268 3.33335C9.33268 3.70154 9.63116 4.00002 9.99935 4.00002Z"
      stroke="#D4D4D4"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99935 8.66669C10.3675 8.66669 10.666 8.36821 10.666 8.00002C10.666 7.63183 10.3675 7.33335 9.99935 7.33335C9.63116 7.33335 9.33268 7.63183 9.33268 8.00002C9.33268 8.36821 9.63116 8.66669 9.99935 8.66669Z"
      stroke="#D4D4D4"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99935 13.3334C10.3675 13.3334 10.666 13.0349 10.666 12.6667C10.666 12.2985 10.3675 12 9.99935 12C9.63116 12 9.33268 12.2985 9.33268 12.6667C9.33268 13.0349 9.63116 13.3334 9.99935 13.3334Z"
      stroke="#D4D4D4"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
